export const navbar = (): void => {
    const navbar = document.querySelector( '.navbar' )

    document.querySelector( '.js-toggle-btn' ).addEventListener( 'click', () => {
        document.querySelector( 'html' ).classList.toggle( 'is-open-menu' );
    } );

    document.querySelectorAll( '.js-filter-btn' ).forEach( button => {
        button.addEventListener( 'click', () => {
            document.querySelector( 'html' ).classList.add( 'is-open-filter' );
            document.querySelector( '.navbar' ).classList.add( 'is-down' );
        } );
    } );

    document.querySelectorAll( '.js-filter-close' ).forEach( button => {
        button.addEventListener( 'click', () => {
            document.querySelector( 'html' ).classList.remove( 'is-open-filter' );
            document.querySelector( '.navbar' ).classList.remove( 'is-down' );
        } );
    } );


    // On Scroll add is-fixed class after 50px and scroll up remove class
    // Function to handle scroll and toggle 'is-up' class
    window.addEventListener( 'scroll', function () {
        const sticky = document.querySelector( 'body' );
        const scroll = window.scrollY;

        if ( scroll >= 50 ) {
            sticky.classList.add( 'is-up' );
        } else {
            sticky.classList.remove( 'is-up' );
        }
    } );

    // Variables to track scroll state
    let lastScroll = 0;
    let isScrolled = false;

    // Function to handle scroll direction and toggle 'is-down' class
    window.addEventListener( 'scroll', function () {
        const topHeader = document.querySelector( 'body' );
        const currentScroll =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;

        const scrollDirection = currentScroll < lastScroll;
        const shouldToggle = isScrolled && scrollDirection;

        isScrolled = currentScroll > 100;
        topHeader.classList.toggle( 'is-down', shouldToggle );
        lastScroll = currentScroll;
    } );

    const categoryDropdown = document.querySelectorAll( '.navbar__menu__nav > li.has-childs' );

    categoryDropdown.forEach( ( item ) => {
        item.addEventListener( 'mouseover', () => {
            navbar.classList.add( 'is-menu-open' );
        } );

        item.addEventListener( 'mouseout', () => {
            navbar.classList.remove( 'is-menu-open' );
        } );
    } );

    const navItems = document.querySelectorAll( '.mobile-nav__nav .nav-item.has-childs > a' );
    navItems.forEach( navItem => {
        navItem.addEventListener( 'click', function ( e ) {
            e.preventDefault(); // Prevent default action
        } );
    } );

    const navbarItems = document.querySelectorAll( '.mobile-nav__nav .nav-item.has-childs > a' );

    if ( window.matchMedia( '(max-width: 1024px)' ) ) {
        Array.from( navbarItems ).forEach( ( navbarItem ) => {
            navbarItem.addEventListener( 'click', () => {
                navbarItem.parentElement.classList.toggle( 'sub-open' );
            } );
        } );
    }

    function closeAllSubMenus() {
        document.querySelectorAll( '.mobile-nav__nav .nav-item' ).forEach( function ( navItem ) {
            navItem.classList.remove( 'sub-open' );
        } );
    }

    document.querySelectorAll( '.js-is-back' ).forEach( function ( button ) {
        button.addEventListener( 'click', function ( e ) {
            e.preventDefault();
            closeAllSubMenus();
        } );
    } );

    if ( document.querySelector( '.section--hero, .section--banner:not(.section--banner--no-image)' ) ) {
        document.querySelector( '.navbar' ).classList.add( 'is-light' );
    }

    document.querySelectorAll( '.js-filter-link' ).forEach( button => {
        button.addEventListener( 'click', function ( e ) {
            const $this = e.currentTarget as HTMLElement;
            const content = $this.nextElementSibling as HTMLElement;

            // Toggle active class
            $this.parentElement.classList.toggle( 'is-active' );

            // Slide Toggle Effect
            if ( content.style.display === "block" ) {
                content.style.display = "none";
            } else {
                content.style.display = "block";
            }
        } );
    } );

    document.querySelectorAll( '[href="#newsletter"]' ).forEach( btn => {
        btn.addEventListener( 'click', function ( e ) {
            e.preventDefault()
            const target = document.querySelector( '#newsletter' );
            const targetPosition = target.getBoundingClientRect().top + window.scrollY - 50;
            window.scrollTo( {
                top: targetPosition,
                behavior: "smooth",
            } )
        } )
    } )

    const nums = document.querySelectorAll( '.js-num' )

    nums?.forEach( num => {
        (num as any).run = true
    } )

    inMiddle()
    window.addEventListener( 'load', inMiddle )
    window.addEventListener( 'resize', inMiddle )
    window.addEventListener( 'scroll', inMiddle )

    function inMiddle() {
        nums?.forEach( num => {
            const rect = num.getBoundingClientRect();
            const pos = rect.top - window.innerHeight * .7
            if ( pos < 0 && (num as any).run ) {
                (num as any).run = false;
                animateCounter( num, parseInt( num.getAttribute( 'data-target' ) ) )
            }
        } )
    }

    function animateCounter( element: Element, target: number, duration = 6000, start = 0 ) {
        if ( !element ) return

        const increment = target / (duration / 16);

        const timer = setInterval( () => {
            start += increment;
            if ( start >= target ) {
                start = target;
                clearInterval( timer );
            }

            element.textContent = Math.floor( start ).toString();
        }, 5 );
    }

};
